export const RANGE_SELECTION_ACTIVATE_KEYS = ['ShiftLeft', 'ControlLeft'];
